










































































// import router from '@/router';
import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { RemainingBalanceRequest } from '@fgl/funfangle-sdk/dist/rest/bank';
import { User } from '@fgl/funfangle-sdk/dist/rest/profile';
// import { UserModule } from '../../store/user';
import { mdbAlert, mdbBtn, mdbCol, mdbContainer, mdbRow } from "mdbvue";
import { ApiEndpoints } from "@/constants";
import { ApiService } from "@/shared/auth/auth-cognito";
import { MediaQuery as MQ } from '@/MediaQuery';
import { ProfileModule } from "@/store/ProfileModule";
import { RouterNames } from '@/router/RouterNames';

const apiSvc = new ApiService();

@Component({
  components: {
    mdbAlert,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbRow
  }
})
export default class RemainingBalance extends Vue {
  public activeSection: string = "#login-form";
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public isLoading: boolean = false;
  public isProcessing: boolean = false;
  public isDonateProcessing: boolean = false;
  public isRefundProcessing: boolean = false;
  RouterNames = RouterNames;
  public MQ = MQ;
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  public users: User[] = [];

  @Prop()
  public organizationId?: string;

  @Prop({ default: false })
  public unauth?: boolean;

  @Prop()
  public userId?: string;

  /** lifecyle: execute when created */
  public created(): void {}

  /** lifecyle: execute when page is mounted */
  public async mounted(): Promise<void> {
    this.refresh();
    // console.log('state', this.stateUserId != null);
  }

  public get authIds(): string[] {
    const ids: string[] = [];
    if (this.users !== undefined) {
      for (const u of this.users) {
        if (u.userId !== undefined) ids.push(u.userId);
      }
    }
    return ids;
  }

  public get showLogo(): boolean {
    return window.location.pathname.indexOf("/offer/remaining") === 0;
  }

  // public get stateUserId(): string | null {
  //   if (this.profileStore.userId != null && this.profileStore.userId !== undefined) return this.profileStore.userId;
  //   return null;
  // }

  public async refresh(): Promise<void> {
    this.loadRemainingBalances();
  }

  public async loadRemainingBalances(): Promise<void> {
    let organizationId = this.organizationId || this.profileStore.organizationId;
    let userId = this.userId || this.profileStore.userId;
    // console.log('oid', organizationId);
    // console.log('uid', userId);
    // console.log('unauth', this.unauth);
    if (organizationId == null) {
      this.errorMessage = 'Organization id not known';
      return;
    }
    if (userId == null) {
      this.errorMessage = 'User id not known';
      return;
    }
    this.isLoading = true;
    const url = `${ApiEndpoints.apiEndpoint}/v2${ this.unauth === true ? '/ua/remainingbalance' : '/bank/balance/remaining' }?organizationId=${organizationId}&userId=${userId}`;
    // console.log('idcard submit', url, req);
    await apiSvc.httpGet(url).then(res => {
      // console.log('res', res);
      if (res && res !== undefined && res.data !== undefined && res.data.items !== undefined) {
        this.users = res.data.items;
      }
    }).catch(err => {
      this.errorMessage = err.message;
      // hasError = true;
    });
    this.isLoading = false;
  }

  public async submitAsDonate(): Promise<void> {
    this.successMessage = null;
    this.isDonateProcessing = true;
    await this.submitRemainingBalances('donate')
      .then(res => {
        if (res !== undefined && res.data !== undefined && res.data.code === 'OK') {
          this.successMessage = 'Thank you for your donation!'
        } else if (res !== undefined && res.data !== undefined && res.data.message !== undefined) {
          this.errorMessage = res.data.message;
        } else {
          this.errorMessage = 'Could not complete action';
        }
      })
      .catch();
    this.isDonateProcessing = false;
    this.isProcessing = false;
  }

  public async submitAsRefund(): Promise<void> {
    this.successMessage = null;
    this.isRefundProcessing = true;
    await this.submitRemainingBalances('refund')
      .then(res => {
        // console.log('res', res);
        if (res !== undefined && res.data !== undefined && res.data.code === 'OK') {
          this.successMessage = 'Your refund has been submitted for processing';
        } else if (res !== undefined && res.data !== undefined && res.data.message !== undefined) {
          this.errorMessage = res.data.message;
        } else {
          this.errorMessage = 'Could not complete action';
        }
      })
      .catch();
    this.isRefundProcessing = false;
    this.isProcessing = false;
  }

  public async submitRemainingBalances(remaining: 'refund' | 'donate'): Promise<any> {
    let organizationId = this.organizationId || this.profileStore.organizationId;
    let userId = this.userId || this.profileStore.userId;
    if (organizationId == null) {
      this.errorMessage = 'Organization id not known';
      return;
    }
    if (userId == null) {
      this.errorMessage = 'User id not known';
      return;
    }
    if (this.authIds == null  || this.authIds === undefined || this.authIds.length === 0) {
      this.errorMessage = 'No participants to process';
      return;
    }
    this.isProcessing = true;
    this.errorMessage = null;
    const url = `${ApiEndpoints.apiEndpoint}/v2${ this.unauth === true ? '/ua/remainingbalance' : '/bank/balance/remaining' }`;
    const data: RemainingBalanceRequest = {
      authIds: this.authIds,
      organizationId,
      remaining,
      userId
    }
    // console.log('httpPost', url, data);
    return apiSvc.httpPost(url, data).catch(err => {
      // console.log('err', err);
      this.errorMessage = err.message;
      // hasError = true;
    });
  }

  /**
   * See if the form elements are valid
   */
  // public formIsValid(): boolean {
  //   // const username = this.username.replace(/^\s+|\s+$/gm, "");
  //   // return /[\S]+/.test(username) && !/[\s]+/.test(username);
  // }
}
